import { configureStore } from "@/lib/store"

export type RecentUserAccessType = "view" | "hijack"

export interface RecentUserEntry {
  id: string
  name: string
  email: string
  organizationName?: string
  lastAccessType: RecentUserAccessType
  lastAccessedAt: string
}

interface RecentUsersState {
  entries: RecentUserEntry[]
  registerAccess: (entry: Omit<RecentUserEntry, "lastAccessedAt">) => void
  clear: () => void
}

const MAX_ENTRIES = 10

export const useRecentUsersStore = configureStore<RecentUsersState>(
  set => ({
    entries: [],

    registerAccess: entry =>
      set(state => {
        const withoutExisting = state.entries.filter(existing => existing.id !== entry.id)
        const updated: RecentUserEntry = {
          ...entry,
          lastAccessedAt: new Date().toISOString(),
        }
        return { entries: [updated, ...withoutExisting].slice(0, MAX_ENTRIES) }
      }),

    clear: () => set({ entries: [] }),
  }),
  {
    persistOptions: {
      name: "admin-recent-users",
    },
  }
)
